module.exports = __webpack_public_path__ + "img/plus.fc0f0855.svg";